import { z } from 'zod'

export const monitoredPatentCoreDetailsSchema = z
  .object({
    document_number: z.string(),
    cpc_section: z.string().nullable().optional(),
    cpc_subclass: z.string().nullable().optional(),
    cpc_symbols: z.array(z.string()).nullable().optional(),
    title: z.string(),
    priority_date: z.string().nullable().optional(),
    publication_date: z.string().nullable().optional(),
  })
  .transform((data) => {
    const {
      cpc_section,
      cpc_subclass,
      cpc_symbols,
      document_number,
      priority_date,
      publication_date,
      ...coreData
    } = data

    return {
      documentNumber: document_number,
      cpcSection: cpc_section,
      cpcSubclass: cpc_subclass,
      cpcSymbols: cpc_symbols,
      priorityDate: priority_date,
      publicationDate: publication_date,
      ...coreData,
    }
  })

export type MonitoredPatentCoreDetails = z.infer<
  typeof monitoredPatentCoreDetailsSchema
>
